/**
 * Die Wertetabelle aus dem Kit: Bezeichnung links, Wert rechts, dünne Linie
 * dazwischen.
 *
 * Als `<dl>` und nicht als Raster aus `<span>` — es ist eine Beschreibungsliste,
 * und eine Sprachausgabe liest sie dann als Paare.
 *
 * `mono` für eine einzelne Zeile: Kennungen, Adressen und Versionen werden
 * abgetippt und verglichen, und in einer Proportionalschrift sehen `0`/`O` und
 * `1`/`l` gleich aus.
 */
import type { Row } from "../lib/device-report.js";

export function DefinitionList({ rows }: { readonly rows: readonly Row[] }) {
  return (
    <dl style={{ margin: 0 }}>
      {rows.map(([key, value], index) => (
        <div
          key={key}
          style={{
            display: "grid",
            gridTemplateColumns: "1fr auto",
            gap: "var(--sp-4)",
            alignItems: "center",
            padding: "9px 0",
            borderBottom: index < rows.length - 1 ? "1px solid var(--border-subtle)" : "none",
          }}
        >
          <dt style={{ fontSize: 13, color: "var(--text-muted)" }}>{key}</dt>
          <dd
            style={{
              margin: 0,
              fontSize: 13,
              fontWeight: 600,
              color: "var(--text-strong)",
              textAlign: "right",
              overflowWrap: "anywhere",
            }}
          >
            {value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
